module.exports = __webpack_public_path__ + "static/media/JordanGreen_2026.55f1a033.jpg";